<template>
  <div class="warpConss chat-list">
    <div v-for="(item, index) in CourseList" :key="index" class="chat-item">
      <div class="item-title" :class="item.isLive == 0 || item.isLive == 2 ? 'noLive' : ''"  >
        <div class="tt-box"  >
          <div class="flex-c ellipsis" :class="
              item.isTrial == 1 && item.isLive == 3 && !IsPurchase
                ? 'course_title'
                : ''
            ">
            <div class="title ellipsis" :class="item.isLive == 1 ? 'lilve-title' : ''">
              <i class="iconfont icon-a-Union21" /> {{ item.liveChapterName }}
            </div>
            <div v-if="item.isLive == 1" class="liveIng" @click.stop="gkZb(item, 1)">
              <i class="live iconfont icon-a-Group1339" /> 正在直播中
            </div>
          </div>
          <div class="time ellipsis">
            {{ item.liveStartTime | format("yyyy.MM.dd HH:mm") }}
          </div>
        </div>
      </div> 
      <div class="but-list">
        <div :class="item.isLive == 0 || item.isLive == 2 ? 'noLives' : ''">
          <div   v-if="item.whetherAttachment" class="keep-learn" @click.stop="goData(item, 1)">
            随堂讲义
          </div>
          <div  v-if="item.whetherPaper" class="keep-learn" @click.stop="cgeckTask(item)">
            随堂测试
          </div>
          <div v-if="item.whetherMeans" class="keep-learn"
            @click.stop="goData(item, 2)">
            随堂资料
          </div>
        </div>
      </div>
    </div>
  
   
  </div>
</template>
<script> 
import Vue from 'vue'  
import { getInfo, getToken } from '@/api/cookies' 
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  props: {
    id: {},
    playid: {},
    list: {},
    classId: {},
    classProductLine: {},
    ccConfig: {
      type: String
    },
    purchase: {
      type: Boolean
    },
    ifClass: {
      type: Boolean
    },
    cardCode: null,
    isFreeze: null
  },
  data () {
    return {
      userInfo: null, 
      CourseList: [],
      dialogVisible: false,
      IsPurchase: false,
      lookDeatil: null,
      showLookDetail: false,
      goBack: false
    }
  },
  
 
  created () {
    this.userInfo = getInfo()
   
      this.CourseList = this.list 
  },
  methods: {
    
 
    // 课堂作业
    cgeckTask (item) {
   Vue.prototype.goExam(      {contactId:item.paperId,examType:6}      );
    },
   

    /* 随堂资料 */
    goData (item, type) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      // if (!this.IsPurchase) {
      //   this.dialogVisible = true
      //   return
      // }
       try {
        const params = new URLSearchParams({
          type: type,
          ChatId: item.liveChapterId,
          courseId: this.id,
        });
        window.open(`/data/dataPackageDetail?${params.toString()}`, "_blank");
      } catch (error) {
        console.error("打开资料详情失败:", error);
      }
      
    }
   
  }
}
</script>
<style lang="less" scoped>
// 缩宽
.warpConss {
  width: 100%;
  height: auto;
  .warpCpons {
    // position: absolute;
    position: fixed;
    z-index: 2000;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: rgba(0, 0, 0, 0.6);
    div {
      width: 610px;
      height: auto;
      // margin-top: 400px;
      display: flex;
      z-index: 20;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      background: rgba(255, 255, 255, 0);
      .imga {
        width: 100%;
        height: 420px;
      }
      .imgb {
        width: 36px;
        height: 36px;
        margin-top: 30px;
        cursor: pointer;
      }
      span {
        width: 100%;
        height: auto;
        text-align: center;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #6c90fe;
        margin-top: -160px;
      }
    }
  }
  // 单个内容展开项盒子
  .warpConskexqq {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 30px 0px;
    .warpConskexq {
      width: 100%;
      height: auto;
      padding: 1px;
      // 某个展开项
      p {
        width: auto;
        height: 13px;
        font-size: 15px;
        margin: 20px 0px 30px 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #27323f;
      }
      .warpConskexqs {
        width: 1175px;
        height: 50px;
        margin: 10px auto;
        background: #f7f7f7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // 左侧
        .warpConskexqsL {
          width: auto;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            width: 4px;
            height: 50px;
            background: #dddddd;
            margin-right: 27px;
          }
          .on {
            background: rgb(107, 187, 251);
          }
          span {
            width: auto;
            height: auto;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            cursor: pointer;
          }
        }
        // 右侧
        .warpConskexqsR {
          width: 320px;
          height: 32px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            width: 90px;
            height: 32px;
            margin-right: 10px;
            border-radius: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.chat-list {
  padding: 0px 32px;
  .chat-item {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .item-title {
      width: calc(100% - 300px);
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: space-between;
      .tt-box {
        width: 100%;
      }
      .lilve-title {
        color: #ff5e51 !important;
      }
      .title {
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }
      .iconfont {
        font-size: 14px;
        margin-right: 12px;
      }
      .time {
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
        margin-top: 12px;
      }
      /* 直播 */
      .liveIng {
        padding: 0px 4px;
        height: 20px;
        background: #ff5e51;
        border-radius: 4px 4px 4px 4px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 8px;
        .live {
          color: #fff;
          font-size: 12px;
          margin-right: 4px;
        }
      }
      /* 回放 */
      .video {
        color: #6c7079;
        font-size: 40px;
      }
    }
    /* 未开始  回放生成中 */
    .noLive {
      color: #9fa4ad;
      .title,
      .time,
      .video {
        color: #9fa4ad !important;
      }
    }
    .noLives {
      .keep-learn {
        border: 1px solid #dddddd;

        border-radius: 4px 4px 4px 4px;
        color: #aaaaaa;
      }
    }
    .but-list {
      flex-shrink: 0;
      display: flex;
      width: 300px;
      justify-content: flex-end;
      .keep-learn {
        margin-right: 10px;
        flex-shrink: 0;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
.course_title::after {
  content: "可试听";
  display: inline-block;
  width: 48px;
  height: 20px;
  color: #ff5e51;
  background-color: #ffedeb;
  border-radius: 2px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin-left: 20px;
}
.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border: 1px solid #ccc;
  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;
    .contents {
      width: 380px;
      margin: 20px auto;
      & > span {
        color: red;
      }
    }
    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
